import { render, staticRenderFns } from "./PracticalQuestion.vue?vue&type=template&id=9a15b44e&"
import script from "./PracticalQuestion.vue?vue&type=script&lang=js&"
export * from "./PracticalQuestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports